import styled from 'styled-components'

import { Link } from 'react-router-dom'

import { theme } from '../../styles/theme'

export const Section = styled.section`
  width: 100%;
  margin: 32px 0;
  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0 100px;
    margin: 64px 0;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 8px;
`

export const SectionTitle = styled.span`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.xxlarge};
  }
`

export const SectionLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.system};
  text-decoration: none;

  svg {
    width: 10px;
    height: 10px;

    path {
      fill: ${theme.colors.system};
    }
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`

export const SectionContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 767px) {
    > :nth-child(n + 4) {
      display: none;
    }
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    gap: 48px;
  }

  p {
    font-size: 12px;
    font-weight: 500;

    @media (min-width: 768px) {
      font-size: 14px;
      grid-column: span 2;
    }
  }
`
